import { render, staticRenderFns } from "./workFlowsIt.vue?vue&type=template&id=702afca1"
import script from "./workFlowsIt.vue?vue&type=script&lang=js"
export * from "./workFlowsIt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports